import React from 'react';
import styled from 'styled-components';

import MoneyExchangeIconSvg from '../../assets/hotels/amenities/MoneyExchange.svg';

const MoneyExchangeIcon = styled(MoneyExchangeIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default MoneyExchangeIcon;
